module.exports = __webpack_public_path__ + "static/media/Timer 3.91d51487.png";